import { Link, NavLink, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Menu, X, Search, User } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Ticker } from "@/components/Ticker";
import { Button } from "@/components/ui/button";

const NAV = [
  { to: "/news", label: "Latest", id: "nav-latest-link" },
  { to: "/news?type=brief", label: "Daily Briefs", id: "nav-briefs-link" },
  { to: "/news?type=analysis", label: "Analysis", id: "nav-analysis-link" },
  { to: "/news?type=newsletter", label: "Tuesday Roast", id: "nav-roast-link" },
  { to: "/research", label: "Research", id: "nav-research-link" },
  { to: "/events", label: "Events", id: "nav-events-link" },
  { to: "/agap", label: "AGAP", id: "nav-agap-link" },
  { to: "/sponsor", label: "Partner With Us", id: "nav-sponsor-link" },
  { to: "/pricing", label: "Pricing", id: "nav-pricing-link" },
];

export const Header = () => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const navigate = useNavigate();
  const onSearch = (e) => { e.preventDefault(); if (q.trim()) navigate(`/news?q=${encodeURIComponent(q)}`); setOpen(false); };

  return (
    <header className="sticky top-0 z-40" data-testid="site-header">
      <Ticker />
      <div className="backdrop-blur-md bg-[#FFFFFF]/90 border-b border-[#E7E7E7]">
        <div className="max-w-7xl mx-auto px-5 lg:px-10 h-16 flex items-center justify-between gap-6">
          <Link to="/" data-testid="brand-logo-link" className="flex items-center gap-3 leading-none">
            <img src="/logo.png" alt="Africa Brew Brief" className="h-12 w-auto" />
            <span className="hidden sm:block overline text-[#575757] !text-[9px] border-l border-[#E7E7E7] pl-3 leading-relaxed">Research<br />Intelligence<br />Context</span>
          </Link>
          <nav className="hidden lg:flex items-center gap-4 xl:gap-5 text-sm whitespace-nowrap">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} data-testid={n.id} className="link-underline text-[#222222] hover:text-[#E5332A] transition-colors">{n.label}</NavLink>
            ))}
          </nav>
          <div className="hidden lg:flex items-center gap-3 shrink-0">
            <form onSubmit={onSearch} className="flex items-center border-b border-[#E7E7E7] focus-within:border-[#E5332A] transition-colors">
              <Search size={14} className="text-[#575757]" />
              <input data-testid="header-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search" className="bg-transparent text-sm px-2 py-1 w-28 outline-none" />
            </form>
            {user ? (
              <Link to={user.role === "admin" ? "/admin" : "/account"} data-testid="header-account-link" className="flex items-center gap-2 text-sm hover:text-[#E5332A]">
                <User size={16} /> {user.role === "admin" ? "Editor desk" : "Account"}
              </Link>
            ) : (
              <Link to="/login" data-testid="header-login-link" className="text-sm whitespace-nowrap hover:text-[#E5332A]">Sign in</Link>
            )}
            {(!user || user.tier === "free") && (
              <Button asChild data-testid="header-subscribe-btn" className="rounded-none bg-[#E5332A] hover:bg-[#B8241C] h-9 px-5">
                <Link to="/pricing">Subscribe</Link>
              </Button>
            )}
          </div>
          <button className="lg:hidden" data-testid="mobile-menu-toggle" onClick={() => setOpen(!open)}>{open ? <X /> : <Menu />}</button>
        </div>
        {open && (
          <div className="lg:hidden border-t border-[#E7E7E7] px-5 py-4 flex flex-col gap-3 bg-[#FFFFFF]" data-testid="mobile-menu">
            <form onSubmit={onSearch}><input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search intelligence" className="w-full border border-[#E7E7E7] px-3 py-2 text-sm bg-white" /></form>
            {NAV.map((n) => <Link key={n.to} to={n.to} onClick={() => setOpen(false)} className="py-1">{n.label}</Link>)}
            <Link to={user ? (user.role === "admin" ? "/admin" : "/account") : "/login"} onClick={() => setOpen(false)} className="py-1 font-medium text-[#E5332A]">{user ? "My account" : "Sign in"}</Link>
          </div>
        )}
      </div>
    </header>
  );
};
